import { /*Map,*/ fromJS } from "immutable";
import { handleActions, createAction } from "redux-actions";
import Restful from "lib/restful";

const EXP_MINUTE = 30;

const SET_IS_WRONG_HASH = "outfitDetail/SET_IS_WRONG_HASH";
const SET_CURRENT_OUTFIT_HASH = "outfitDetail/SET_CURRENT_OUTFIT_HASH";
const EXPORT_OUTFIT_DETAIL = "outfitDetail/EXPORT_OUTFIT_DETAIL";
const EXPORT_MEMO_OBJ = "outfitDetail/EXPORT_MEMO_OBJ";
const SET_IS_LOADING = "outfitDetail/SET_IS_LOADING";
const SET_INFO_DATA = "outfitDetail/SET_INFO_DATA";
const SET_ITEM_DATA = "outfitDetail/SET_ITEM_DATA";
const SET_CALENDAR_DATA = "outfitDetail/SET_CALENDAR_DATA";
const SET_MEMO_OBJ = "outfitDetail/SET_MEMO_OBJ";
const INIT_BOOKMARK_DATA = "outfitDetail/INIT_BOOKMARK_DATA";
const SET_BOOKMARK_VALUE = "outfitDetail/SET_BOOKMARK_VALUE";
const SET_BOOKMARK_FOLDER = "outfitDetail/SET_BOOKMARK_FOLDER";
const INIT_PICK_DATA = "outfitDetail/INIT_PICK_DATA";
const SET_PICK_VALUE = "outfitDetail/SET_PICK_VALUE";
const SET_PICK_FOLDER = "outfitDetail/SET_PICK_FOLDER";
const SET_EXPIRATION_DATE = "outfitDetail/SET_EXPIRATION_DATE";
const SET_IS_BOOKMARK_LOADING_OF_TARGET =
  "outfitDetail/SET_IS_BOOKMARK_LOADING_OF_TARGET";
const SET_IS_BOOKMARK_FOLDER_LOADING_OF_TARGET =
  "outfitDetail/SET_IS_BOOKMARK_FOLDER_LOADING_OF_TARGET";
const SET_IS_PICK_LOADING_OF_TARGET =
  "outfitDetail/SET_IS_PICK_LOADING_OF_TARGET";
const SET_IS_PICK_FOLDER_LOADING_OF_TARGET =
  "outfitDetail/SET_IS_PICK_FOLDER_LOADING_OF_TARGET";
const REMOVE_OUTFIT_DETAIL = "outfitDetail/REMOVE_OUTFIT_DETAIL";
const REMOVE_EXPORTED_DATA = "outfitDetail/REMOVE_EXPORTED_DATA";
const SET_THUMBNAIL = "outfitDetail/SET_THUMBNAIL";
const REMOVE_THUMBNAIL = "outfitDetail/REMOVE_THUMBNAIL";
const UPDATE_NICKNAME_FROM_DATA = "outfitDetail/UPDATE_NICKNAME_FROM_DATA";
const INIT_ALL_DATA = "outfitDetail/INIT_ALL_DATA";

const setIsWrongHash = createAction(SET_IS_WRONG_HASH);
const setCurrentOutfitHash = createAction(SET_CURRENT_OUTFIT_HASH);
const exportOutfitDetail = createAction(EXPORT_OUTFIT_DETAIL);
const exportMemoObj = createAction(EXPORT_MEMO_OBJ);
const setIsLoading = createAction(SET_IS_LOADING);
const setInfoData = createAction(SET_INFO_DATA);
const setItemData = createAction(SET_ITEM_DATA);
const setCalendarData = createAction(SET_CALENDAR_DATA);
const setMemoObj = createAction(SET_MEMO_OBJ);
const initBookmarkData = createAction(INIT_BOOKMARK_DATA);
const setBookmarkValue = createAction(SET_BOOKMARK_VALUE);
const setBookmarkFolder = createAction(SET_BOOKMARK_FOLDER);
const initPickData = createAction(INIT_PICK_DATA);
const setPickValue = createAction(SET_PICK_VALUE);
const setPickFolder = createAction(SET_PICK_FOLDER);
const setExpirationDate = createAction(SET_EXPIRATION_DATE);
const setIsBookmarkLoadingOfTarget = createAction(
  SET_IS_BOOKMARK_LOADING_OF_TARGET
);
const setIsBookmarkFolderLoadingOfTarget = createAction(
  SET_IS_BOOKMARK_FOLDER_LOADING_OF_TARGET
);
const setIsPickLoadingOfTarget = createAction(SET_IS_PICK_LOADING_OF_TARGET);
const setIsPickFolderLoadingOfTarget = createAction(
  SET_IS_PICK_FOLDER_LOADING_OF_TARGET
);
const removeOutfitDetail = createAction(REMOVE_OUTFIT_DETAIL);
const removeExportedData = createAction(REMOVE_EXPORTED_DATA);
const setThumbnail = createAction(SET_THUMBNAIL);
const removeThumbnail = createAction(REMOVE_THUMBNAIL);
const updateNicknameFromData = createAction(UPDATE_NICKNAME_FROM_DATA);
const initAllData = createAction(INIT_ALL_DATA);

const hasLoggedIn = ({ getState }) => {
  const { myAccount } = getState();
  const { hasLoggedIn } = myAccount.toJS();
  return hasLoggedIn;
};

const getUsername = ({ getState }) => {
  const { myAccount } = getState();
  const { username } = myAccount.toJS();
  return username;
};

const nullish = (input, second) => {
  return input === undefined || input === null ? second : input;
};

const removeElementFromArray = (array, value) => {
  return array.filter((element, index) => {
    if (element === value) {
      return false;
    }
    return true;
  });
};

const getOutfitDetailState = ({ getState }) => {
  const outfitDetailState = getState().outfitDetail.toJS();
  return outfitDetailState;
};

const getTargetHashData = ({ getState, outfitHash }) => {
  const outfitDetailState = getOutfitDetailState({ getState });
  const { dataObj } = outfitDetailState;
  return dataObj[outfitHash] || {};
};

const getListWithUpdatedNickname = (inputArray, itemHash, nickname) => {
  return inputArray.map(unit => {
    if (unit.itemHash === itemHash) {
      return { ...unit, nickname };
    }
    return unit;
  });
};

const getDataObjWithUpdatedNickname = (inputObj, itemHash, nickname) => {
  const returnObj = {};

  for (const outfitHash in inputObj) {
    if (inputObj.hasOwnProperty(outfitHash)) {
      const newItemList = getListWithUpdatedNickname(
        inputObj[outfitHash].item,
        itemHash,
        nickname
      );
      returnObj[outfitHash] = inputObj[outfitHash];
      returnObj[outfitHash].item = newItemList;
    }
  }

  return returnObj;
};

const getIsDataLoading = ({ getState, outfitHash }) => {
  const { isLoading } = getTargetHashData({ getState, outfitHash });
  return { isDataLoading: !!isLoading };
};

const checkExpDate = ({ getState, outfitHash }) => {
  const { expirationDate } = getTargetHashData({ getState, outfitHash });
  if (!expirationDate) return { needUpdate: true };
  const nowDate = new Date();
  return { needUpdate: nowDate > expirationDate ? true : false };
};

const setNewExpDate = ({ dispatch, outfitHash, dataType }) => {
  const expirationDate = new Date();
  if (dataType === "forMember") {
    expirationDate.setMinutes(expirationDate.getMinutes() + EXP_MINUTE);
  }
  dispatch(setExpirationDate({ outfitHash, expirationDate }));
};

const getIsMyOutfit = ({ outfitHash, getState }) => {
  if (!hasLoggedIn({ getState })) return false;
  const username = getUsername({ getState });
  const { info } = getTargetHashData({ getState, outfitHash });
  const { ownerName } = info;
  if (!ownerName) {
    /** 사용자정보를 받아오기전 이 함수가 실행되면 올바른 값을 리턴하지 못한다. */
    console.error("unknown ownerName");
  }
  return username === ownerName;
};

const exportData = ({ getState, dispatch, outfitHash, type }) => {
  switch (type) {
    case "info":
    case "item":
    case "calendar":
    case "bookmark":
    case "pick":
    case "all":
      break;
    default:
      throw Error(`unknown exportData type => type:"${type}"`);
  }
  const { currentOutfitHash } = getOutfitDetailState({ getState });
  if (outfitHash === currentOutfitHash) {
    dispatch(exportOutfitDetail({ outfitHash, type }));
  }
};

const exportMemo = ({ getState, dispatch, outfitHash }) => {
  const { currentOutfitHash } = getOutfitDetailState({ getState });
  if (outfitHash === currentOutfitHash) {
    const { calendar } = getTargetHashData({ getState, outfitHash });
    dispatch(exportMemoObj({ date: calendar.date }));
  }
};

const requestInfoData = async ({ outfitHash, dispatch }) => {
  const { code, res, errInfo } = await Restful.getInfoOfOutfitAPI(outfitHash);
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  } else if (code === "WrongHash") {
    return true;
  }
  dispatch(setInfoData({ outfitHash, info: res.info }));
  return false;
};

const requestItemData = async ({
  outfitHash,
  needRealtimeData = false,
  dispatch,
  getState,
  idToken
}) => {
  let restAPIFunc, restAPIInput;
  if (!getIsMyOutfit({ outfitHash, getState })) {
    restAPIFunc = Restful.getItemOfOutfitAPI;
    restAPIInput = { outfitHash, needRealtimeData };
  } else {
    restAPIFunc = Restful.getItemOfMyOutfitAPI;
    restAPIInput = { outfitHash, needRealtimeData, idToken };
  }

  const { code, res, errInfo } = await restAPIFunc(restAPIInput);
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  }

  const item = res.item;
  if (item) {
    dispatch(setItemData({ outfitHash, item }));
  }
};

const requestBookmarkData = async ({
  outfitHash,
  dispatch,
  getState,
  idToken
}) => {
  if (!hasLoggedIn({ getState })) return null;

  const { code, res, errInfo } = await Restful.getBookmarkInfoOfOutfitAPI({
    outfitHash,
    idToken
  });
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  }

  const { bookmark, folder } = res;
  const newFolder = !folder ? [] : folder;
  dispatch(setBookmarkValue({ outfitHash, value: bookmark }));
  dispatch(setBookmarkFolder({ outfitHash, type: "init", value: newFolder }));
};

const toggleBookmarkButton = ({ outfitHash, dispatch, getState }) => {
  const { bookmark } = getTargetHashData({ getState, outfitHash });
  const { isBookmarked } = bookmark;
  dispatch(setBookmarkValue({ outfitHash, value: !isBookmarked }));
};

const toggleBookmarkFolderButton = ({
  outfitHash,
  folderHash,
  dispatch,
  getState
}) => {
  const { bookmark } = getTargetHashData({ getState, outfitHash });
  const { bookmarkedFolder } = bookmark;
  const type = bookmarkedFolder.includes(folderHash) ? "remove" : "add";
  dispatch(setBookmarkFolder({ outfitHash, type, value: folderHash }));
};

const togglePickButton = ({ outfitHash, dispatch, getState }) => {
  const { pick } = getTargetHashData({ getState, outfitHash });
  const { isPicked } = pick;
  dispatch(setPickValue({ outfitHash, value: !isPicked }));
};

const togglePickFolderButton = ({
  outfitHash,
  folderHash,
  dispatch,
  getState
}) => {
  const { pick } = getTargetHashData({ getState, outfitHash });
  const { pickedFolder } = pick;
  const type = pickedFolder.includes(folderHash) ? "remove" : "add";
  dispatch(setPickFolder({ outfitHash, type, value: folderHash }));
};

const requestPickData = async ({ outfitHash, dispatch, getState, idToken }) => {
  if (!hasLoggedIn({ getState })) return null;

  const { code, res, errInfo } = await Restful.getPickInfoOfOutfitAPI({
    outfitHash,
    idToken
  });
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  }

  const { pick, folder } = res;
  const newFolder = !folder ? [] : folder;
  dispatch(setPickValue({ outfitHash, value: pick }));
  dispatch(setPickFolder({ outfitHash, type: "init", value: newFolder }));
};

const requestCalendarData = async ({
  outfitHash,
  needRealtimeData = false,
  dispatch,
  getState,
  idToken
}) => {
  if (!hasLoggedIn({ getState })) return null;

  if (!getIsMyOutfit({ outfitHash, getState })) return null;

  const { code, res, errInfo } = await Restful.getCalendarOfOutfitAPI({
    outfitHash,
    needRealtimeData,
    idToken
  });
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  }

  const { calendar, memo } = res;
  const { date, display } = calendar;
  dispatch(setCalendarData({ outfitHash, date, display }));
  dispatch(setMemoObj({ date, memo }));
};

const exportThumbnailData = ({ dispatch, getState, outfitHash }) => {
  const { thumbnailObj } = getOutfitDetailState({ getState });
  const targetObj = thumbnailObj[outfitHash];
  if (!targetObj) return null;

  const { image } = targetObj;
  dispatch(setInfoData({ outfitHash, info: { outfitImage: image } }));
  exportData({ getState, dispatch, outfitHash, type: "info" });
};

const displayInfo = async ({ dispatch, getState, outfitHash }) => {
  const { info } = getTargetHashData({ getState, outfitHash });
  let isWrongHash = false;
  if (!info) {
    exportThumbnailData({ dispatch, getState, outfitHash });
    isWrongHash = await requestInfoData({ outfitHash, dispatch });
  }

  if (isWrongHash) {
    dispatch(setIsWrongHash(true));
  } else {
    exportData({ getState, dispatch, outfitHash, type: "info" });
  }
  return isWrongHash;
};

const displayBookmark = async ({
  dispatch,
  getState,
  dataType,
  outfitHash,
  idToken
}) => {
  dispatch(initBookmarkData({ outfitHash }));

  if (dataType === "forGuest") return null;

  if (getIsMyOutfit({ outfitHash, getState })) return null;

  const { bookmark } = getTargetHashData({ getState, outfitHash });
  if (typeof bookmark.isBookmarked !== "boolean") {
    await requestBookmarkData({ outfitHash, dispatch, getState, idToken });
  }
  exportData({ getState, dispatch, outfitHash, type: "bookmark" });
};

const displayPick = async ({
  dispatch,
  getState,
  dataType,
  outfitHash,
  idToken
}) => {
  dispatch(initPickData({ outfitHash }));

  if (dataType === "forGuest") return null;

  if (!getIsMyOutfit({ outfitHash, getState })) return null;

  const { pick } = getTargetHashData({ getState, outfitHash });
  if (typeof pick.isPicked !== "boolean") {
    await requestPickData({ outfitHash, dispatch, getState, idToken });
  }
  exportData({ getState, dispatch, outfitHash, type: "pick" });
};

const displayItem = async ({
  dispatch,
  getState,
  outfitHash,
  dataType,
  mustUpdate,
  idToken
}) => {
  const { item } = getTargetHashData({ getState, outfitHash });
  if (item) {
    exportData({ getState, dispatch, outfitHash, type: "item" });
  }

  if (item && dataType === "forGuest") return null;

  if (mustUpdate || !item) {
    await requestItemData({ outfitHash, dispatch, getState, idToken });
  }

  exportData({ getState, dispatch, outfitHash, type: "item" });
};

const displayCalendar = async ({ dispatch, getState, outfitHash, idToken }) => {
  if (!hasLoggedIn({ getState })) return null;

  if (!getIsMyOutfit({ outfitHash, getState })) return null;

  const { calendar } = getTargetHashData({ getState, outfitHash });
  if (calendar) {
    exportData({ getState, dispatch, outfitHash, type: "calendar" });
    exportMemo({ getState, dispatch, outfitHash });
  }

  await requestCalendarData({ outfitHash, dispatch, getState, idToken });

  exportData({ getState, dispatch, outfitHash, type: "calendar" });
  exportMemo({ getState, dispatch, outfitHash });
};

const displayNewOutfit = async ({
  dispatch,
  getState,
  outfitHash,
  dataType,
  idToken
}) => {
  dispatch(removeExportedData());

  const { isDataLoading } = getIsDataLoading({ getState, outfitHash });
  if (isDataLoading) return null;

  dispatch(setIsLoading({ outfitHash, isLoading: true }));

  const { needUpdate } = checkExpDate({ getState, outfitHash });
  let mustUpdate = false;
  if (needUpdate) {
    mustUpdate = true;
    setNewExpDate({ dispatch, outfitHash, dataType });
  }

  const [isWrongHash] = await Promise.all([
    displayInfo({ dispatch, getState, outfitHash })
  ]);

  if (dataType === "forGuest") {
    displayItem({ dispatch, getState, outfitHash, dataType, mustUpdate });
  } else if (!isWrongHash) {
    await Promise.all([
      displayBookmark({ dispatch, getState, dataType, outfitHash, idToken }),
      displayPick({ dispatch, getState, dataType, outfitHash, idToken }),
      displayItem({
        dispatch,
        getState,
        outfitHash,
        dataType,
        mustUpdate,
        idToken
      }),
      displayCalendar({ dispatch, getState, outfitHash, idToken })
    ]);
  }

  dispatch(setIsLoading({ outfitHash, isLoading: false }));

  exportData({ getState, dispatch, outfitHash, type: "all" });
};

export const changeOutfitDetail =
  ({ outfitHash, idToken }) =>
  async (dispatch, getState) => {
    dispatch(setCurrentOutfitHash(outfitHash));

    const dataType = hasLoggedIn({ getState }) ? "forMember" : "forGuest";

    await displayNewOutfit({
      dispatch,
      getState,
      outfitHash,
      dataType,
      idToken
    });
  };

export const changeBookmarkData =
  ({ outfitHash, idToken }) =>
  async (dispatch, getState) => {
    if (!hasLoggedIn({ getState })) return {};

    const { bookmark } = getTargetHashData({ getState, outfitHash });
    const { isBookmarkLoading, isBookmarked } = bookmark;

    if (isBookmarkLoading) return {};

    dispatch(
      setIsBookmarkLoadingOfTarget({ outfitHash, isBookmarkLoading: true })
    );

    toggleBookmarkButton({ outfitHash, dispatch, getState });
    exportData({ getState, dispatch, outfitHash, type: "bookmark" });

    let newBookmark;
    let needCreative = undefined;
    if (isBookmarked) {
      dispatch(setBookmarkFolder({ outfitHash, type: "init", value: [] }));
      exportData({ getState, dispatch, outfitHash, type: "bookmark" });

      const { code, res, errInfo } = await Restful.removeBookmarkAPI({
        outfitHash,
        idToken
      });
      if (code === "error") {
        await requestBookmarkData({ outfitHash, dispatch, getState, idToken });
        exportData({ getState, dispatch, outfitHash, type: "bookmark" });
        dispatch(
          setIsBookmarkLoadingOfTarget({ outfitHash, isBookmarkLoading: false })
        );
        const errObj = Error("api error");
        errObj.errorValue = { ...errInfo };
        throw errObj;
      }
      newBookmark = res.bookmark;
    } else {
      const { code, res, errInfo } = await Restful.setBookmarkAPI({
        outfitHash,
        idToken
      });
      if (code === "ok") {
        newBookmark = res.bookmark;
        needCreative = res.needCreative;
      } else {
        toggleBookmarkButton({ outfitHash, dispatch, getState });
        exportData({ getState, dispatch, outfitHash, type: "bookmark" });
        dispatch(
          setIsBookmarkLoadingOfTarget({ outfitHash, isBookmarkLoading: false })
        );
        if (code === "error") {
          const errObj = Error("api error");
          errObj.errorValue = { ...errInfo };
          throw errObj;
        } else if (code === "DeletedOutfit") {
          throw Error("DeletedOutfit");
        }
      }
    }

    dispatch(setBookmarkValue({ outfitHash, value: newBookmark }));
    exportData({ getState, dispatch, outfitHash, type: "bookmark" });

    dispatch(
      setIsBookmarkLoadingOfTarget({ outfitHash, isBookmarkLoading: false })
    );
    return { needCreative };
  };

export const changeBookmarkFolderData =
  ({ outfitHash, folderHash, idToken }) =>
  async (dispatch, getState) => {
    if (!hasLoggedIn({ getState })) return {};

    const { bookmark } = getTargetHashData({ getState, outfitHash });
    const { isLoadingForFolder, bookmarkedFolder } = bookmark;

    if (isLoadingForFolder.includes(folderHash)) return {};

    dispatch(
      setIsBookmarkFolderLoadingOfTarget({
        outfitHash,
        folderHash,
        setFolderLoading: true
      })
    );

    toggleBookmarkFolderButton({ outfitHash, folderHash, dispatch, getState });
    exportData({ getState, dispatch, outfitHash, type: "bookmark" });

    let newBookmark;
    if (bookmarkedFolder.includes(folderHash)) {
      const { code, res, errInfo } = await Restful.removeBookmarkToFolderAPI({
        outfitHash,
        bookmarkFolderHash: folderHash,
        idToken
      });
      if (code === "error") {
        const errObj = Error("api error");
        errObj.errorValue = { ...errInfo };
        throw errObj;
      }

      newBookmark = res.bookmark;
      if (newBookmark) {
        dispatch(
          setBookmarkFolder({ outfitHash, type: "add", value: folderHash })
        );
      }
    } else {
      const { code, res, errInfo } = await Restful.setBookmarkToFolderAPI({
        outfitHash,
        bookmarkFolderHash: folderHash,
        idToken
      });

      if (code === "error") {
        const errObj = Error("api error");
        errObj.errorValue = { ...errInfo };
        throw errObj;
      }

      newBookmark = res.bookmark;
      if (!newBookmark) {
        dispatch(
          setBookmarkFolder({ outfitHash, type: "remove", value: folderHash })
        );
      }
    }

    exportData({ getState, dispatch, outfitHash, type: "bookmark" });

    dispatch(
      setIsBookmarkFolderLoadingOfTarget({
        outfitHash,
        folderHash,
        setFolderLoading: false
      })
    );
    return {};
  };

export const changePickData =
  ({ outfitHash, idToken }) =>
  async (dispatch, getState) => {
    if (!hasLoggedIn({ getState })) return {};

    const { pick } = getTargetHashData({ getState, outfitHash });
    const { isPickLoading, isPicked } = pick;

    if (isPickLoading) return {};

    dispatch(setIsPickLoadingOfTarget({ outfitHash, isPickLoading: true }));

    togglePickButton({ outfitHash, dispatch, getState });
    exportData({ getState, dispatch, outfitHash, type: "pick" });

    let newPick;
    if (isPicked) {
      dispatch(setPickFolder({ outfitHash, type: "init", value: [] }));
      exportData({ getState, dispatch, outfitHash, type: "pick" });

      const { code, res, errInfo } = await Restful.removePickAPI({
        outfitHash,
        idToken
      });
      if (code === "error") {
        await requestPickData({ outfitHash, dispatch, getState, idToken });
        exportData({ getState, dispatch, outfitHash, type: "pick" });
        dispatch(
          setIsPickLoadingOfTarget({ outfitHash, isPickLoading: false })
        );
        const errObj = Error("api error");
        errObj.errorValue = { ...errInfo };
        throw errObj;
      }
      newPick = res.pick;
    } else {
      const { code, res, errInfo } = await Restful.setPickAPI({
        outfitHash,
        idToken
      });
      if (code === "ok") {
        newPick = res.pick;
      } else {
        togglePickButton({ outfitHash, dispatch, getState });
        exportData({ getState, dispatch, outfitHash, type: "pick" });
        dispatch(
          setIsPickLoadingOfTarget({ outfitHash, isPickLoading: false })
        );
        if (code === "error") {
          const errObj = Error("api error");
          errObj.errorValue = { ...errInfo };
          throw errObj;
        } else if (code === "DeletedOutfit") {
          throw Error("DeletedOutfit");
        }
      }
    }

    dispatch(setPickValue({ outfitHash, value: newPick }));
    exportData({ getState, dispatch, outfitHash, type: "pick" });

    dispatch(setIsPickLoadingOfTarget({ outfitHash, isPickLoading: false }));
    return {};
  };

export const changePickFolderData =
  ({ outfitHash, folderHash, idToken }) =>
  async (dispatch, getState) => {
    if (!hasLoggedIn({ getState })) return {};

    const { pick } = getTargetHashData({ getState, outfitHash });
    const { isLoadingForFolder, pickedFolder } = pick;

    if (isLoadingForFolder.includes(folderHash)) return {};

    dispatch(
      setIsPickFolderLoadingOfTarget({
        outfitHash,
        folderHash,
        setFolderLoading: true
      })
    );

    togglePickFolderButton({ outfitHash, folderHash, dispatch, getState });
    exportData({ getState, dispatch, outfitHash, type: "pick" });

    let newPick;
    if (pickedFolder.includes(folderHash)) {
      const { code, res, errInfo } = await Restful.removePickToFolderAPI({
        outfitHash,
        pickFolderHash: folderHash,
        idToken
      });
      if (code === "error") {
        const errObj = Error("api error");
        errObj.errorValue = { ...errInfo };
        throw errObj;
      }

      newPick = res.pick;
      if (newPick) {
        dispatch(setPickFolder({ outfitHash, type: "add", value: folderHash }));
      }
    } else {
      const { code, res, errInfo } = await Restful.setPickToFolderAPI({
        outfitHash,
        pickFolderHash: folderHash,
        idToken
      });

      if (code === "error") {
        const errObj = Error("api error");
        errObj.errorValue = { ...errInfo };
        throw errObj;
      }

      newPick = res.pick;
      if (!newPick) {
        dispatch(
          setPickFolder({ outfitHash, type: "remove", value: folderHash })
        );
      }
    }

    exportData({ getState, dispatch, outfitHash, type: "pick" });

    dispatch(
      setIsPickFolderLoadingOfTarget({
        outfitHash,
        folderHash,
        setFolderLoading: false
      })
    );
    return {};
  };

export const rewriteItemOfOutfit =
  ({ outfitHash, itemArray, calendarDate, calendarAgreement, idToken }) =>
  async (dispatch, getState) => {
    if (!getIsMyOutfit({ outfitHash, getState })) {
      throw Error("permission error");
    }

    const { code, errInfo } = await Restful.editItemOfOutfitAPI({
      outfitHash,
      idToken,
      data: {
        items: itemArray,
        date: calendarDate,
        display: !!calendarAgreement ? "y" : "n"
      }
    });
    if (code === "error") {
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      throw errObj;
    } else if (code === "UnauthorizedUser") {
      throw Error(`UnauthorizedUser => outfitHash:"${outfitHash}"`);
    } else if (code === "UnknownOutfit") {
      return "UnknownOutfit";
    }

    await Promise.all([
      requestItemData({
        outfitHash,
        needRealtimeData: true,
        dispatch,
        getState,
        idToken
      }),
      requestCalendarData({
        outfitHash,
        needRealtimeData: true,
        dispatch,
        getState,
        idToken
      })
    ]);
    exportData({ getState, dispatch, outfitHash, type: "item" });
    exportData({ getState, dispatch, outfitHash, type: "calendar" });
    return "ok";
  };

export const addThumbnailData =
  ({ outfitHash, image }) =>
  (dispatch, getState) => {
    dispatch(setThumbnail({ outfitHash, image }));
  };

export const updateNicknameFromItem =
  ({ itemHash, nickname }) =>
  async (dispatch, getState) => {
    dispatch(updateNicknameFromData({ itemHash, nickname }));
  };

export const writeOutfitMemoData =
  ({ outfitHash, date, memoObj, idToken }) =>
  async (dispatch, getState) => {
    const { who, where, what, etc } = memoObj;

    const { code, res, errInfo } = await Restful.setMemoOfOutfitAPI({
      date,
      data: { memoData: { who, where, what, etc } },
      idToken
    });
    if (code === "error") {
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      throw errObj;
    }

    const { memoData } = res;
    dispatch(setMemoObj({ date, memo: memoData }));
    exportMemo({ getState, dispatch, outfitHash });
  };

export const deleteOutfitDetail = outfitHash => (dispatch, getState) => {
  if (!getIsMyOutfit({ outfitHash, getState })) {
    throw Error("permission error");
  }

  dispatch(removeOutfitDetail(outfitHash));
  dispatch(removeThumbnail(outfitHash));
  dispatch(setIsWrongHash(false));
  dispatch(removeExportedData());
};

export const clearExportedData = () => (dispatch, getState) => {
  dispatch(setCurrentOutfitHash(null));
  dispatch(removeExportedData());
};

export const deleteAllData = () => (dispatch, getState) => {
  dispatch(initAllData());
};

const initialState = fromJS({
  dataObj: {},
  /*
  dataObj 의 구조.
  dataObj: {
    [outfitHash]: {
      isLoading: false,
      info: {},
      item: [],
      calendar: {
        date: "20XX-YY-ZZ",
        isDisplay: false
      }, // or null
      bookmark: {
        isBookmarkLoading: false,
        isLoadingForFolder: [],
        isBookmarked: false,
        bookmarkedFolder: []
      },
      pick: {
        isPickLoading: false,
        isLoadingForFolder: [],
        isPicked: false,
        pickedFolder: []
      },
      expirationDate: null,
    }
  },
  */

  thumbnailObj: {},
  /*
  thumbnailObj 의 구조.
  thumbnailObj: {
    [outfitHash]: {
      image: null,
    }
  },
  */

  memoObj: {},
  /*
  memoObj 의 구조.
  memoObj: {
    [date]: { // "20XX-YY-ZZ",
      who: null,
      where: null,
      what: null,
      etc: null
    }
  },
  */

  currentOutfitHash: null,

  isWrongHash: false,

  infoData: {
    ownerName: null,
    profileImage: null,
    outfitImage: null,
    gender: null,
    userLocation: null
  },

  itemData: null,

  calendarData: null,

  bookmarkData: null,

  pickData: null,

  memoData: {
    who: null,
    where: null,
    what: null,
    etc: null
  }
});

export default handleActions(
  {
    [SET_CURRENT_OUTFIT_HASH]: (state, action) => {
      const currentOutfitHash = action.payload;
      return state.set("currentOutfitHash", fromJS(currentOutfitHash));
    },
    [SET_IS_WRONG_HASH]: (state, action) => {
      const isWrongHash = action.payload;
      return state.set("isWrongHash", fromJS(isWrongHash));
    },
    [EXPORT_OUTFIT_DETAIL]: (state, action) => {
      const { outfitHash, type } = action.payload;
      const {
        dataObj,
        infoData,
        itemData,
        calendarData,
        bookmarkData,
        pickData
      } = state.toJS();
      const { info, item, calendar, bookmark, pick } = dataObj[outfitHash];
      let resState = state;
      if (type === "info" || type === "all") {
        resState = resState.set("infoData", fromJS(nullish(info, infoData)));
      }
      if (type === "item" || type === "all") {
        resState = resState.set("itemData", fromJS(nullish(item, itemData)));
      }
      if (type === "calendar" || type === "all") {
        resState = resState.set(
          "calendarData",
          fromJS(nullish(calendar, calendarData))
        );
      }
      if (type === "bookmark" || type === "all") {
        resState = resState.set(
          "bookmarkData",
          fromJS(nullish(bookmark, bookmarkData))
        );
      }
      if (type === "pick" || type === "all") {
        resState = resState.set("pickData", fromJS(nullish(pick, pickData)));
      }
      return resState;
    },
    [EXPORT_MEMO_OBJ]: (state, action) => {
      const { date } = action.payload;
      const { memoObj } = state.toJS();
      return state.set("memoData", fromJS(memoObj[date]));
    },
    [SET_IS_LOADING]: (state, action) => {
      const { outfitHash, isLoading } = action.payload;
      return state.setIn(
        ["dataObj", outfitHash, "isLoading"],
        fromJS(isLoading)
      );
    },
    [SET_INFO_DATA]: (state, action) => {
      const { outfitHash, info } = action.payload;
      return state.setIn(["dataObj", outfitHash, "info"], fromJS(info));
    },
    [SET_ITEM_DATA]: (state, action) => {
      const { outfitHash, item } = action.payload;
      return state.setIn(["dataObj", outfitHash, "item"], fromJS(item));
    },
    [SET_CALENDAR_DATA]: (state, action) => {
      const { outfitHash, date, display } = action.payload;
      const isDisplay = display === "y" ? true : false;
      const calendarData = { date, isDisplay };
      return state.setIn(
        ["dataObj", outfitHash, "calendar"],
        fromJS(calendarData)
      );
    },
    [SET_MEMO_OBJ]: (state, action) => {
      const { date, memo } = action.payload;
      return state.setIn(["memoObj", date], fromJS(memo));
    },
    [INIT_BOOKMARK_DATA]: (state, action) => {
      const { outfitHash } = action.payload;
      const initObj = {
        isBookmarkLoading: false,
        isLoadingForFolder: [],
        isBookmarked: null,
        bookmarkedFolder: []
      };
      return state.setIn(["dataObj", outfitHash, "bookmark"], fromJS(initObj));
    },
    [SET_BOOKMARK_VALUE]: (state, action) => {
      const { outfitHash, value } = action.payload;
      return state.setIn(
        ["dataObj", outfitHash, "bookmark", "isBookmarked"],
        fromJS(value)
      );
    },
    [SET_BOOKMARK_FOLDER]: (state, action) => {
      /**
       * type === init 인 경우는 value가 배열만 가능
       * type === add 인 경우는 value가 문자, 배열 둘다가능(근데 배열 비추)
       * type === remove 인 경우는 value가 문자만 가능
       */
      const { outfitHash, type, value } = action.payload;
      const { dataObj } = state.toJS();
      const { bookmarkedFolder } = dataObj[outfitHash].bookmark;
      let newFolderArr;
      if (type === "init") {
        newFolderArr = value;
      } else if (type === "add") {
        newFolderArr = bookmarkedFolder.concat(value);
      } else if (type === "remove") {
        newFolderArr = removeElementFromArray(bookmarkedFolder, value);
      }
      return state.setIn(
        ["dataObj", outfitHash, "bookmark", "bookmarkedFolder"],
        fromJS(newFolderArr)
      );
    },
    [INIT_PICK_DATA]: (state, action) => {
      const { outfitHash } = action.payload;
      const initObj = {
        isPickLoading: false,
        isLoadingForFolder: [],
        isPicked: null,
        pickedFolder: []
      };
      return state.setIn(["dataObj", outfitHash, "pick"], fromJS(initObj));
    },
    [SET_PICK_VALUE]: (state, action) => {
      const { outfitHash, value } = action.payload;
      return state.setIn(
        ["dataObj", outfitHash, "pick", "isPicked"],
        fromJS(value)
      );
    },
    [SET_PICK_FOLDER]: (state, action) => {
      /**
       * type === init 인 경우는 value가 배열만 가능
       * type === add 인 경우는 value가 문자, 배열 둘다가능(근데 배열 비추)
       * type === remove 인 경우는 value가 문자만 가능
       */
      const { outfitHash, type, value } = action.payload;
      const { dataObj } = state.toJS();
      const { pickedFolder } = dataObj[outfitHash].pick;
      let newFolderArr;
      if (type === "init") {
        newFolderArr = value;
      } else if (type === "add") {
        newFolderArr = pickedFolder.concat(value);
      } else if (type === "remove") {
        newFolderArr = removeElementFromArray(pickedFolder, value);
      }
      return state.setIn(
        ["dataObj", outfitHash, "pick", "pickedFolder"],
        fromJS(newFolderArr)
      );
    },
    [SET_EXPIRATION_DATE]: (state, action) => {
      const { outfitHash, expirationDate } = action.payload;
      return state.setIn(
        ["dataObj", outfitHash, "expirationDate"],
        fromJS(expirationDate)
      );
    },
    [SET_IS_BOOKMARK_LOADING_OF_TARGET]: (state, action) => {
      const { outfitHash, isBookmarkLoading } = action.payload;
      return state.setIn(
        ["dataObj", outfitHash, "bookmark", "isBookmarkLoading"],
        isBookmarkLoading
      );
    },
    [SET_IS_BOOKMARK_FOLDER_LOADING_OF_TARGET]: (state, action) => {
      const { outfitHash, folderHash, setFolderLoading } = action.payload;
      const { dataObj } = state.toJS();
      const { isLoadingForFolder } = dataObj[outfitHash].bookmark;
      let newLoadingArr;
      if (setFolderLoading) {
        newLoadingArr = isLoadingForFolder.concat(folderHash);
      } else {
        newLoadingArr = removeElementFromArray(isLoadingForFolder, folderHash);
      }
      return state.setIn(
        ["dataObj", outfitHash, "bookmark", "isLoadingForFolder"],
        newLoadingArr
      );
    },
    [SET_IS_PICK_LOADING_OF_TARGET]: (state, action) => {
      const { outfitHash, isPickLoading } = action.payload;
      return state.setIn(
        ["dataObj", outfitHash, "pick", "isPickLoading"],
        isPickLoading
      );
    },
    [SET_IS_PICK_FOLDER_LOADING_OF_TARGET]: (state, action) => {
      const { outfitHash, folderHash, setFolderLoading } = action.payload;
      const { dataObj } = state.toJS();
      const { isLoadingForFolder } = dataObj[outfitHash].pick;
      let newLoadingArr;
      if (setFolderLoading) {
        newLoadingArr = isLoadingForFolder.concat(folderHash);
      } else {
        newLoadingArr = removeElementFromArray(isLoadingForFolder, folderHash);
      }
      return state.setIn(
        ["dataObj", outfitHash, "pick", "isLoadingForFolder"],
        newLoadingArr
      );
    },
    [REMOVE_OUTFIT_DETAIL]: (state, action) => {
      const outfitHash = action.payload;
      return state.removeIn(["dataObj", outfitHash]);
    },
    [REMOVE_EXPORTED_DATA]: (state, action) => {
      const {
        isWrongHash,
        infoData,
        itemData,
        calendarData,
        memoData,
        bookmarkData,
        pickData
      } = initialState.toJS();
      return state
        .set("isWrongHash", fromJS(isWrongHash))
        .set("infoData", fromJS(infoData))
        .set("itemData", fromJS(itemData))
        .set("calendarData", fromJS(calendarData))
        .set("memoData", fromJS(memoData))
        .set("bookmarkData", fromJS(bookmarkData))
        .set("pickData", fromJS(pickData));
    },
    [SET_THUMBNAIL]: (state, action) => {
      const { outfitHash, image } = action.payload;
      return state.setIn(["thumbnailObj", outfitHash, "image"], fromJS(image));
    },
    [REMOVE_THUMBNAIL]: (state, action) => {
      const outfitHash = action.payload;
      return state.removeIn(["thumbnailObj", outfitHash]);
    },
    [UPDATE_NICKNAME_FROM_DATA]: (state, action) => {
      const { itemHash, nickname } = action.payload;
      const { dataObj } = state.toJS();
      const newData = getDataObjWithUpdatedNickname(
        dataObj,
        itemHash,
        nickname
      );
      return state.set("dataObj", fromJS(newData));
    },
    [INIT_ALL_DATA]: (state, action) => {
      return initialState;
    }
  },
  initialState
);
